const variations = {
  singleVars: document.querySelectorAll(
    '.product-variations__single',
  ) as NodeListOf<HTMLElement>,

  init() {
    this.checkVariations();
    this.reset();
  },

  reset() {
    window.addEventListener('reset', () => {
      this.checkVariations();
    });
  },

  checkVariations() {
    this.singleVars.forEach((item) => {
      const selected = item.querySelector(
        '._itmspec_selected span',
      ) as HTMLElement | null;
      const wrap = item.querySelector('.jsSelected') as HTMLElement | null;

      if (!wrap) return;

      wrap.innerHTML = '';

      if (selected) {
        wrap.innerHTML += selected.innerHTML;
      }
    });
  },
};

export default variations;
